import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, retry } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ChangeLogItem {
  id: string;
  projectId: string;
  crNumber: string;
  dateRequested: string;
  changeDescription: string;
  priority: string;
  status: string;
  effortEstimateDays?: number;
  plannedDate?: string;
  actualDate?: string;
  comments?: string;
}

export interface CreateChangeLogItemDto {
  projectId: string;
  crNumber: string;
  dateRequested: string;
  changeDescription: string;
  priority: string;
  status: string;
  effortEstimateDays?: number;
  plannedDate?: string;
  actualDate?: string;
  comments?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ChangeLogItemService {
  private apiUrl = `${environment.apiUrl}/ChangeLogItem`;

  constructor(private http: HttpClient) { }

  getByProjectId(projectId: string): Observable<ChangeLogItem[]> {
    return this.http.get<ChangeLogItem[]>(`${this.apiUrl}/project/${projectId}`);
  }

  getById(id: string): Observable<ChangeLogItem> {
    return this.http.get<ChangeLogItem>(`${this.apiUrl}/${id}`);
  }

  addItem(item: CreateChangeLogItemDto): Observable<ChangeLogItem> {
    return this.http.post<ChangeLogItem>(this.apiUrl, item);
  }

  updateItem(id: string, item: ChangeLogItem): Observable<ChangeLogItem> {
    return this.http.put<ChangeLogItem>(`${this.apiUrl}/${id}`, item);
  }

  deleteItem(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}


